import moment from 'moment-timezone';

import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('booking');
const GET_BOOKING = define('GET_BOOKING', true);
const CONFIRM_TRIP = define('CONFIRM_TRIP', true);
const UNDO_CONFIRM_TRIP = define('UNDO_CONFIRM_TRIP', true);
const CANCEL_TRIP = define('CANCEL_TRIP', true);
const UNDO_RESCHEDULING = define('UNDO_RESCHEDULING', true);
const SEND_EMAIL = define('SEND_EMAIL', true);
const SWAP_LX = define('SWAP_LX', true);
const CREATE_SWAP_REQUEST = define('CREATE_SWAP_REQUEST', true);
const CHANGE_TRIP_DATE = define('CHANGE_TRIP_DATE', true);
const CHANGE_QUANTITY = define('CHANGE_QUANTITY', true);
const CHANGE_LISTED_PRICE = define('CHANGE_LISTED_PRICE', true);
const UPDATE_BOOKING = define('UPDATE_BOOKING', true);
const SAVE_NOTE = define('SAVE_NOTE', true);
const CONFIRM_PAYMENT = define('CONFIRM_PAYMENT', true);
const REFUND_BOOKING = define('REFUND_BOOKING', true);
const ADD_ADDITIONAL_PAYMENT = define('ADD_ADDITIONAL_PAYMENT', true);
const MANAGE_ADDITIONAL_PAYMENT = define('MANAGE_ADDITIONAL_PAYMENT', true);
const UPDATE_ADDTIONAL_OPTIONS = define('UPDATE_ADDTIONAL_OPTIONS', true);
const ACCEPT_HOTEL_PICKUP = define('ACCEPT_HOTEL_PICKUP', true);
const REGENERATE_RECEIPT = define('REGENERATE_RECEIPT', true);
const RECALCULATE_PRICE = define('RECALCULATE_PRICE', true);
const CHARGE_OMISE = define('CHARGE_OMISE', true);
const BOOK_GLOBALTIX = define('BOOK_GLOBALTIX', true);
const UPDATE_PRICE_CONSTANT = define('UPDATE_PRICE_CONSTANT', true);
const REMOVE_LX_IMAGE = define('REMOVE_LX_IMAGE', true);
const GET_BOOKING_DASHBOARD = define('GET_BOOKING_DASHBOARD', true);
const GET_BOOKING_PROMO = define('GET_BOOKING_PROMO', true);
const SAVE_INSURANCE = define('SAVE_INSURANCE', true);
const APPEND_SWAP_REQUEST_BY_TIER = define('APPEND_SWAP_REQUEST_BY_TIER', true);
const APPEND_SWAP_REQUEST_MANUAL = define('APPEND_SWAP_REQUEST_MANUAL', true);
const GET_BOOKING_MANUAL_BOOKING = define('GET_BOOKING_MANUAL_BOOKING', true);
const CLEAR_MANUAL_BOOKING = define('CLEAR_MANUAL_BOOKING');

const initialState = {
  isLoading: true,
  booking: {},
  processing: false,
  isLoadingDashboard: true,
  isLoadingBookingPromo: true,
  isLoadingManualBooking: true,
  dashboard: [],
  bookingPromo: [],
  manualBooking: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKING.PENDING:
      return {
        ...state,
        booking: {},
        isLoading: true,
      };
    case GET_BOOKING.RESOLVED:
      return {
        ...state,
        isLoading: false,
        booking: action.data
      };
    case GET_BOOKING_DASHBOARD.PENDING:
      return {
        ...state,
        isLoadingDashboard: true
      };
    case GET_BOOKING_DASHBOARD.RESOLVED:
      return {
        ...state,
        isLoadingDashboard: false,
        dashboard: action.data
      };
    case GET_BOOKING_PROMO.PENDING:
      return {
        ...state,
        isLoadingBookingPromo: true
      };
    case GET_BOOKING_PROMO.RESOLVED:
      return {
        ...state,
        isLoadingBookingPromo: false,
        bookingPromo: action.data
      };
    case GET_BOOKING_MANUAL_BOOKING.PENDING:
      return {
        ...state,
        isLoadingManualBooking: true
      };
    case GET_BOOKING_MANUAL_BOOKING.RESOLVED:
      return {
        ...state,
        isLoadingManualBooking: false,
        manualBooking: action.data
      };
    case CLEAR_MANUAL_BOOKING:
      return {
        ...state,
        isLoadingManualBooking: false,
        manualBooking: []
      };
    case CONFIRM_TRIP.PENDING:
    case UNDO_CONFIRM_TRIP.PENDING:
    case CANCEL_TRIP.PENDING:
    case UNDO_RESCHEDULING.PENDING:
    case SEND_EMAIL.PENDING:
    case SWAP_LX.PENDING:
    case CHANGE_TRIP_DATE.PENDING:
    case CHANGE_QUANTITY.PENDING:
    case CHANGE_LISTED_PRICE.PENDING:
    case UPDATE_BOOKING.PENDING:
    case SAVE_NOTE.PENDING:
    case CONFIRM_PAYMENT.PENDING:
    case REFUND_BOOKING.PENDING:
    case ADD_ADDITIONAL_PAYMENT.PENDING:
    case MANAGE_ADDITIONAL_PAYMENT.PENDING:
    case UPDATE_ADDTIONAL_OPTIONS.PENDING:
    case ACCEPT_HOTEL_PICKUP.PENDING:
    case REGENERATE_RECEIPT.PENDING:
    case RECALCULATE_PRICE.PENDING:
    case CHARGE_OMISE.PENDING:
    case UPDATE_PRICE_CONSTANT.PENDING:
    case REMOVE_LX_IMAGE.PENDING:
    case BOOK_GLOBALTIX.PENDING:
    case CREATE_SWAP_REQUEST.PENDING:
    case SAVE_INSURANCE.PENDING:
    case APPEND_SWAP_REQUEST_BY_TIER.PENDING:
    case APPEND_SWAP_REQUEST_MANUAL.PENDING:
      return {
        ...state,
        processing: true
      };
    case CONFIRM_TRIP.RESOLVED:
    case UNDO_CONFIRM_TRIP.RESOLVED:
    case CANCEL_TRIP.RESOLVED:
    case UNDO_RESCHEDULING.RESOLVED:
    case SEND_EMAIL.RESOLVED:
    case SWAP_LX.RESOLVED:
    case CHANGE_TRIP_DATE.RESOLVED:
    case CHANGE_QUANTITY.RESOLVED:
    case CHANGE_LISTED_PRICE.RESOLVED:
    case UPDATE_BOOKING.RESOLVED:
    case SAVE_NOTE.RESOLVED:
    case CONFIRM_PAYMENT.RESOLVED:
    case REFUND_BOOKING.RESOLVED:
    case ADD_ADDITIONAL_PAYMENT.RESOLVED:
    case MANAGE_ADDITIONAL_PAYMENT.RESOLVED:
    case UPDATE_ADDTIONAL_OPTIONS.RESOLVED:
    case ACCEPT_HOTEL_PICKUP.RESOLVED:
    case REGENERATE_RECEIPT.RESOLVED:
    case RECALCULATE_PRICE.RESOLVED:
    case CHARGE_OMISE.RESOLVED:
    case UPDATE_PRICE_CONSTANT.RESOLVED:
    case REMOVE_LX_IMAGE.RESOLVED:
    case BOOK_GLOBALTIX.RESOLVED:
    case CREATE_SWAP_REQUEST.RESOLVED:
    case SAVE_INSURANCE.RESOLVED:
    case APPEND_SWAP_REQUEST_BY_TIER.RESOLVED:
    case APPEND_SWAP_REQUEST_MANUAL.RESOLVED:
      return {
        ...state,
        processing: false
      };
    case CONFIRM_TRIP.REJECTED:
    case UNDO_CONFIRM_TRIP.REJECTED:
    case CANCEL_TRIP.REJECTED:
    case UNDO_RESCHEDULING.REJECTED:
    case SEND_EMAIL.REJECTED:
    case SWAP_LX.REJECTED:
    case CHANGE_TRIP_DATE.REJECTED:
    case CHANGE_QUANTITY.REJECTED:
    case CHANGE_LISTED_PRICE.REJECTED:
    case UPDATE_BOOKING.REJECTED:
    case SAVE_NOTE.REJECTED:
    case CONFIRM_PAYMENT.REJECTED:
    case REFUND_BOOKING.REJECTED:
    case ADD_ADDITIONAL_PAYMENT.REJECTED:
    case MANAGE_ADDITIONAL_PAYMENT.REJECTED:
    case UPDATE_ADDTIONAL_OPTIONS.REJECTED:
    case ACCEPT_HOTEL_PICKUP.REJECTED:
    case REGENERATE_RECEIPT.REJECTED:
    case RECALCULATE_PRICE.REJECTED:
    case CHARGE_OMISE.REJECTED:
    case UPDATE_PRICE_CONSTANT.REJECTED:
    case REMOVE_LX_IMAGE.REJECTED:
    case BOOK_GLOBALTIX.REJECTED:
    case CREATE_SWAP_REQUEST.REJECTED:
    case SAVE_INSURANCE.REJECTED:
    case APPEND_SWAP_REQUEST_BY_TIER.REJECTED:
    case APPEND_SWAP_REQUEST_MANUAL.REJECTED:
      return {
        ...state,
        processing: false
      };
    default: return state;
  }
};

export const actions = {
  loadBooking: id => ({
    type: GET_BOOKING,
    promise: api.get(`/bookings/${id}`),
    error: 'Unable to load booking data'
  }),
  confirmTrip: id => ({
    type: CONFIRM_TRIP,
    promise: api.post(`/bookings/${id}/admin/confirm`),
    success: 'Trip has been confirmed',
    error: 'Unable to confirm trip'
  }),
  chargeOmise: id => ({
    type: CHARGE_OMISE,
    promise: api.post(`/bookings/${id}/admin/charge-omise`),
    success: 'Charged by omise',
    error: 'Unable to charge the booking'
  }),
  bookGlobaltix: id => ({
    type: BOOK_GLOBALTIX,
    promise: api.post(`/bookings/${id}/admin/book-globaltix`),
    success: 'Booked to GlobalTix success',
    error: 'Unable to book to globaltix'
  }),
  undoConfirmTrip: id => ({
    type: UNDO_CONFIRM_TRIP,
    promise: api.post(`/bookings/${id}/admin/undo-confirm`),
    success: 'Confirmation has been undone.',
    error: 'Unable to undo confirm'
  }),
  cancelTrip: id => ({
    type: CANCEL_TRIP,
    promise: api.post(`/bookings/${id}/admin/cancel`),
    success: 'Trip has been canceled',
    error: 'Unable to cancel trip'
  }),
  undoRescheduling: id => ({
    type: UNDO_RESCHEDULING,
    promise: api.post(`/bookings/${id}/undo-send7`),
    success: 'Rescheduling has been undone.',
    error: 'Unable to undo rescheduling'
  }),
  sendEmail: (id, type) => ({
    type: SEND_EMAIL,
    promise: api.post(`/mail/booking/${id}/${type}`),
    success: 'Email has been sent',
    error: 'Unable to send email'
  }),
  swapLx: (id, lxId, isSkipConfirm) => ({
    type: SWAP_LX,
    promise: api.post(`/bookings/${id}/swap`, {
      lx_id: lxId,
      is_skip_confirm: isSkipConfirm
    }),
    success: 'Local Expert has been swapped to new one',
    error: 'Unable to swap to new Local Expert'
  }),
  changeTripDate: (id, newDate) => ({
    type: CHANGE_TRIP_DATE,
    promise: api.post(`/bookings/${id}/admin/change-date`, { trip_date: newDate }),
    success: 'Trip date has been changed',
    error: 'Unable to change trip date'
  }),
  changeQuantity: (id, quantity) => ({
    type: CHANGE_QUANTITY,
    promise: api.post(`/bookings/${id}/admin/change-quantity`, { quantity }),
    success: 'Trip number of guest(s) has been changed',
    error: 'Unable to change number of guest(s)'
  }),
  changeListedPrice: (id, price) => ({
    type: CHANGE_LISTED_PRICE,
    promise: api.post(`/bookings/${id}/admin/change-price`, { price }),
    success: 'Trip listed price has been changed',
    error: 'Unable to change listed price'
  }),
  saveNote: (id, note) => ({
    type: SAVE_NOTE,
    promise: api.put(`/bookings/${id}/note`, { note }),
    success: 'Note has been saved',
    error: 'Unable to save note'
  }),
  confirmPayment: (id, type, date) => ({
    type: CONFIRM_PAYMENT,
    promise: api.post(`/bookings/${id}/admin/confirm-payment`, {
      charged_type: type,
      charged_date: date
    }),
    success: 'Payment for this booking has been confirmed',
    error: 'Unable to confirmed payment'
  }),
  refund: (id, amount, isDeductFromLx, note) => ({
    type: REFUND_BOOKING,
    promise: api.post(`/bookings/${id}/admin/refund`, { amount, is_deduct_from_lx: isDeductFromLx, note }),
    success: 'Booking has been refunded',
    error: 'Unable to refund booking'
  }),
  addAdditionalPayment: (id, text, amount) => ({
    type: ADD_ADDITIONAL_PAYMENT,
    promise: api.post(`/bookings/${id}/additional-payment`, { text, amount }),
    success: 'Additional Payment has been added',
    error: 'Unable to add new additional payment'
  }),
  manageAdditionalPayment: (id, toBeStatus, paymentId, approvalNote) => {
    return {
      type: MANAGE_ADDITIONAL_PAYMENT,
      promise: api.post(`/bookings/${id}/manage-additional-payment`, { toBeStatus, paymentId, approvalNote }),
      success: 'Additional Payment updated',
      error: 'Unable to update additional payment'
    };
  },
  addAdditionalOption: (id, data) => ({
    type: UPDATE_ADDTIONAL_OPTIONS,
    promise: api.post(`/bookings/${id}/admin/change-additional-options`, { selected_options: data }),
    success: 'Addtional Option has been updated',
    error: 'Unable to update new additional option'
  }),
  acceptHotelPickup: (id, isAccept) => ({
    type: ACCEPT_HOTEL_PICKUP,
    promise: api.post(`/bookings/${id}/lx-accept-hotel`, { isAccept }),
    success: 'Accept hotel pickup',
    error: 'Unable to accept hotel pickup'
  }),
  regenerateReceipt: (id) => ({
    type: REGENERATE_RECEIPT,
    promise: api.post(`/bookings/${id}/admin/generate-receipt`),
    success: 'Booking receipt has been regenerated',
    error: 'Unable to regenerate receipt'
  }),
  regeneratePrice: (id) => ({
    type: RECALCULATE_PRICE,
    promise: api.post(`/bookings/${id}/admin/generate-price`),
    success: 'Price has been recalculated',
    error: 'Unable to recalculate price'
  }),
  updatePriceConstant: (id, data) => ({
    type: UPDATE_PRICE_CONSTANT,
    promise: api.post(`/bookings/${id}/admin/change-price-const`, { price_const: data }),
    success: 'Price constant has been updated',
    error: 'Unable to update price constant'
  }),
  removeLxImage: id => ({
    type: REMOVE_LX_IMAGE,
    promise: api.post(`/bookings/${id}/remove-lx-image`),
    success: 'LX Image has been removed',
    error: 'Unable to remove LX Image'
  }),
  getBookingDashboard: (from = moment().subtract(2, 'days').startOf('days').format('YYYY-MM-DD'), to = moment().endOf('days').format('YYYY-MM-DD')) => ({
    type: GET_BOOKING_DASHBOARD,
    promise: api.get(`/bookings/dashboard?from=${from}&to=${to}`),
    error: 'Fail to load booking dashboard'
  }),
  getBookingPromo: (month = moment().format('YYYY-MM')) => ({
    type: GET_BOOKING_PROMO,
    promise: api.get(`/bookings/redeem?month=${month}`),
    error: 'Fail to load booking promo'
  }),
  getBookingManualBook: (type, monthYear = moment().format('YYYY-MM'), dateType = 'tripDate') => ({
    type: GET_BOOKING_MANUAL_BOOKING,
    promise: api.get(`/bookings/admin/booking-manual-book-type?type=${type}&monthYear=${monthYear}&dateType=${dateType}`),
    error: 'Fail to load bookings'
  }),
  clearManualBooking: () => ({
    type: CLEAR_MANUAL_BOOKING,
  }),
  saveInsuranceData: (id, data) => ({
    type: SAVE_INSURANCE,
    promise: api.post(`/bookings/${id}/insurance`, data),
    success: 'Insurance info submitted!',
    error: 'Fail to submit insurance'
  }),
  // swap actions
  createSwapRequest: (id, lxIds) => ({
    type: CREATE_SWAP_REQUEST,
    promise: api.post(`/bookings/${id}/admin/swap-request`, {
      local_experts: lxIds,
    }),
    success: 'Swap request has been created and sent',
    error: 'Unable to create swap request'
  }),
  createSwapRequestByTier: (id, tier, isPartner = false) => ({
    type: CREATE_SWAP_REQUEST,
    promise: api.post(`/bookings/${id}/admin/swap-request-tier`, {
      tier,
      isPartner
    }),
    success: 'Tier swap request has been created and sent',
    error: 'Unable to create tier swap request'
  }),
  appendLxByTier: (id, tier) => ({
    type: APPEND_SWAP_REQUEST_BY_TIER,
    promise: api.post(`/swap-request/${id}/append-swap-request`, { tier }),
    success: `Swap Request list sent by tier ${tier}`,
    error: 'Fail to append swap request'
  }),
  manualAppend: (id, lxs) => ({
    type: APPEND_SWAP_REQUEST_MANUAL,
    promise: api.post(`/swap-request/${id}/append-swap-request`, { tier: 0, local_expert_ids: lxs }),
    success: 'Swap Request list sent manually',
    error: 'Fail to append swap request'
  }),
  updateBooking: (id, data) => ({
    type: UPDATE_BOOKING,
    promise: api.post(`/bookings/${id}/admin/update`, data),
    success: 'Booking has been updated',
    error: 'Fail to update booking'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/booking.js